export default (invoices: any[]) => {
  return invoices.sort((a, b) => b.createdAt.seconds - a.createdAt.seconds);
}
